module.exports = __webpack_public_path__ + "static/media/p22_names.9f2284c8.txt";